module.exports = __webpack_public_path__ + "images/ds-bf2024-banner-block-laptop.webp";